import { ColorsEnum } from "../../et3-theme/colors";

const ALPHA_HOVER = "14";
const ALPHA_SHADOW = "1F";

export const PICKER_BLOCK_HEIGHT = 75;
export const PICKER_INDICATOR_SIZE = 16;
export const PICKER_OPTION_FONT_SIZE = 16;
export const PICKER_OPTION_MIN_HEIGHT = 38;
export const PICKER_OPTION_PADDING = 12;
export const PICKER_MENU_MAX_HEIGHT = 300;
export const PICKER_MENU_OFFSET = 6;
export const PICKER_BADGE_WIDTH = 44;
export const PICKER_BADGE_HEIGHT = 20;
export const PICKER_BADGE_RADIUS = 10;
export const PICKER_BADGE_FONT_SIZE = 12;

export const PICKER_OPTION_HOVER = `${ColorsEnum.bondiBlue}${ALPHA_HOVER}`;
export const PICKER_MENU_SHADOW = `0 8px 24px ${ColorsEnum.maastrichtBlue}${ALPHA_SHADOW}`;
